import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { User } from '@shared/models';

import { UserActionsUnion, UsersActionTypes } from './users.actions';

export const usersAdapter = createEntityAdapter<User>({
  selectId: (user: User) => user.id,
  sortComparer: false,
});

export interface UsersState extends EntityState<User> {
  loggedInUser: User | null;
}

export const initialState: UsersState = usersAdapter.getInitialState({
  loggedInUser: null,
});

export function usersReducer(
  state: UsersState = initialState,
  { type, payload }: UserActionsUnion,
) {
  switch (type) {
    case UsersActionTypes.LoadSuccess:
      return usersAdapter.setAll(payload.content, state);

    case UsersActionTypes.ListSuccess:
      return usersAdapter.addMany(payload.users, state);

    case UsersActionTypes.GetSuccess:
    case UsersActionTypes.CreateSuccess:
      return usersAdapter.addOne(payload, state);

    case UsersActionTypes.LoggedInSuccess: {
      return usersAdapter.addOne(payload, { ...state, loggedInUser: payload });
    }

    case UsersActionTypes.UpdateSuccess:
      return usersAdapter.upsertOne(payload, state);

    case UsersActionTypes.UpdateLoggedInUserSuccess:
      return usersAdapter.upsertOne(payload, { ...state, loggedInUser: payload });

    case UsersActionTypes.DeleteSuccess:
      return usersAdapter.removeOne(payload.id, state);

    default:
      return state;
  }
}
